import { render, staticRenderFns } from "./CompareMeasurement.vue?vue&type=template&id=4925e5f8&scoped=true"
import script from "./CompareMeasurement.vue?vue&type=script&lang=js"
export * from "./CompareMeasurement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4925e5f8",
  null
  
)

export default component.exports